<template>
<v-container app :fluid="true" class="pt-0">
    <v-row>
        <v-col cols="3">
            <v-autocomplete
                :items="customers"
                dense
                solo
                clearable 
                clear-icon="far fa-times-circle"               
                label="Clientes"
                persistent-hint
                :item-text="customText"
                item-value="id"
                hide-details
                @change="handleSelecteCustomer"
                :filter="customFilter"
            >
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title v-if="data.item.type_document === 'DNI' ">{{ data.item.name }} {{ data.item.surname }}</v-list-item-title>
                        <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.type_document }}: {{ data.item.document }}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
        </v-col>

        <v-col cols="3">
            <v-menu
                v-model="menuFromDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="from_date"
                    label="Desde"
                    solo
                    dense
                    readonly
                    clearable
                    v-on="on"
                    @click:clear="handleClearFrom"
                    hide-details                                    
                    ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" @input="menuFromDate = false" no-title @change="handleChangeFormDate">
                </v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="3">
            <v-menu
                v-model="menuUntilDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="until_date"
                    label="Hasta"
                    solo
                    dense
                    readonly
                    clearable
                    v-on="on"
                    @click:clear="handleClearUntil"
                    hide-details
                    ></v-text-field>
                </template>
                <v-date-picker v-model="until_date" @input="menuUntilDate = false" no-title @change="handleChangeUntilDate"></v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="3">
            <v-btn dark color="green" 
                @click="handleExportExcel"
                v-if="verifyPermission('exportar_reporte_deudas')">
                XLS
            </v-btn>
        </v-col>

    </v-row>
    <v-row>
        <v-col cols="12">
            <v-card>
                 <template>
                     <v-col cols="12" class="pt-0 pl-0 pr-0">
                         <v-data-table
                            class="wost-table"
                            :headers="headers"
                            :items="debts"
                            item-key="id"
                            height="65vh"
                            show-expand
                            :single-expand="true"
                            fixed-header
                        >
                            <template v-slot:item.type="{ item }">
                                {{ item.customer.type }}
                            </template>

                            <template v-slot:item.document="{ item }">
                                {{ item.customer.document }}
                            </template>

                            <template v-slot:item.name="{ item }">
                                <span v-if="item.customer.type == 'Natural'">
                                    {{ item.customer.name }} {{ item.customer.surname }} 
                                </span>
                                <span v-else>
                                    {{ item.customer.name }}
                                </span>
                            </template>

                            <template v-slot:item.entry_date="{ item }">
                                {{ item.entry_date | moment("DD/MM/YYYY") }}
                            </template>

                            <template v-slot:item.amount="{ item }">
                                {{ item.amount | currency('S/') }}
                            </template>

                            <template v-slot:item.amount_paid="{ item }">
                                <span class="amount-paid">{{ item.amount_paid | currency('S/') }}</span>
                            </template>

                            <template v-slot:item.amount_pending="{ item }">
                                <span class="amount-pending">{{ item.amount_pending | currency('S/') }}</span>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <span :class="'status-debt status-debt-' + item.status">{{ item.status | capitalize }}</span>
                            </template>

                            <template v-slot:item.payment_date="{ item }">
                                {{ item.payment_date | moment("DD/MM/YYYY") }}
                            </template>

                            <template v-slot:expanded-item="{ item, headers }">
                                <td :colspan="headers.length" class="wost-td-expanded">
                                    <debt-detail :payments="item.payments"></debt-detail>
                                </td>
                            </template>

                        </v-data-table>
                     </v-col>
                 </template>
            </v-card>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import XLSX from 'xlsx'

import { mapActions, mapMutations, mapState } from 'vuex';

import ApiReports from '../../apis/Reports'
import DebtDetail from '../../components/Reports/DebtDetail'
import Tools from '../../helpers/Tools'

export default {
    name: 'Debts',
    components: {
        DebtDetail
    },
    data() {
        return {
            headers: [
                { text: 'Tipo Cliente', value: 'type', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Documento', value: 'document', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Cliente', value: 'name', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Fecha', value: 'entry_date', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Monto de Deuda', value: 'amount', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Monto Pagado', value: 'amount_paid', sortable: false, class: 'header-table' },
                { text: 'Monto Pendiente', value: 'amount_pending', sortable: false, class: 'header-table' },
                { text: 'Estado', value: 'status', sortable: false, class: 'header-table' },
                { text: 'F. de Pago', value: 'payment_date', sortable: false, class: 'header-table' },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ],
            customer_id: null,
            value_customer: '',
            debts: [],
            menuFromDate: false,
            from_date: null,
            menuUntilDate: false,
            until_date: null
        }
    },
    computed: {
        ...mapState('orders', [
            'customers'
        ])
    },
    methods: {
        ...mapActions('orders', [
            'getCustomers'
        ]),
        getDebts(){
            let params = {
                customer_id: this.customer_id,
                from: this.from_date,
                until: this.until_date
            }
            ApiReports.debts(params)
                    .then(({data}) => {
                        this.debts = data
                    })
        },
        handleClearFrom(){
            this.from_date = null
            this.getDebts()
        },
        handleClearUntil(){
            this.until_date = null
            this.getDebts()
        },
        handleChangeFormDate(){
            this.getDebts()
        },
        handleChangeUntilDate(){
            this.getDebts()
        },
        customText(item){
            let text = item.name
            if (item.type_document === 'DNI') {
                text = item.name + ' ' + item.surname
            }
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();             
            }

            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();
            }
            
            let searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleSelecteCustomer(value){
            this.customer_id = null            
            if(value !== undefined && value !== null){
                this.customer_id = value
            }
            this.getDebts()
        },
        handleExportExcel(){
            let data = XLSX.utils.json_to_sheet(
                this.prepareDataExport(this.debts),
                {
                    header: ['type', 'document', 'name', 'entry_date', 'amount', 'amount_paid', 'amount_pending', 'status', 'payment_date']
                }
            )
            data['A1'].v = 'Tipo Cliente'
            data['B1'].v = 'Documento'
            data['C1'].v = 'Cliente'
            data['D1'].v = 'Fecha'
            data['E1'].v = 'Monto de Deuda'
            data['F1'].v = 'Monto Pagado'
            data['G1'].v = 'Monto Pendiente'
            data['H1'].v = 'Estado'
            data['I1'].v = 'Fecha de Pago'
            const workbook = XLSX.utils.book_new()
            const filename = 'reporte-de-deudas'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        },
        prepareDataExport(debts){
            let dataExport = []
            debts.forEach(element => {
                let name = element.customer.name
                if (element.customer.type == 'Natural') {
                    name = element.customer.name + ' ' + element.customer.surname
                }
                
                let itemData = {
                    type: element.customer.type,
                    document: element.customer.document,
                    name: name,
                    entry_date:  Tools.setFormatDate(new Date(element.entry_date)),
                    amount: element.amount,
                    amount_paid: element.amount_paid,
                    amount_pending: element.amount_pending,
                    status: element.status,
                    payment_date: Tools.setFormatDate(new Date(element.entry_date))
                }
                dataExport.push(itemData)
            })
            return dataExport
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created () {
        this.getCustomers();
    },
    mounted() {
        this.getDebts()
    }
}
</script>

<style>
.status-debt{
    display: inline-block;
    width: 80px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
}

.status-debt-pagada{
    color: #43A047 !important;
    font-weight: 500;
    border: 1px solid;
}

.status-debt-pendiente{
    color: #FFC107 !important;
    font-weight: 500;
    border: 1px solid;
}

.amount-paid{
    color: #43A047 !important;
    font-weight: 500;
}

.amount-pending{
    color: #FFC107 !important;
    font-weight: 500;
}
</style>